<script>
import _ from "lodash";

const TheStudentScholarshipScoreCard = () => import("../../Cards/Student/TheStudentScholarshipScoreCard.vue");

const TheStudentAchievementsStatementsTable = () => import("../../Tables/Student/TheStudentAchievementsStatementsTable.vue");
export default {
  name: "TheStudentShowStatementDialog",

  props: {
    visible: Boolean,
    statementStudent: Object,
  },

  components: {
    TheStudentScholarshipScoreCard,
    TheStudentAchievementsStatementsTable,
  },

  data() {
    return {
      defaultScore: {
        "sum_score_education": 0.0,
        "sum_score_research": 0.0,
        "sum_score_social_activity": 0.0,
        "sum_score_cultural_creative": 0.0,
        "sum_score_sports": 0.0,
        "sum_score": 0.0,
      }
    };
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },

    statementScores() {
      const scores = this.statementStudent?.person_scores;

      if (_.isNil(scores)) return this.defaultScore;
      else return scores[0];
    },

    statementAchievements() {
      return this.statementStudent?.achievements || [];
    },

    achievementType() {
      if (_.isEmpty(this.statementStudent)) return ""
      return this.statementStudent.prtf_achievement_type_name;
    },

    personFullName() {
      return this.statementStudent?.person?.full_name || "";
    }
  },

}
</script>

<template>
  <v-dialog
    v-model="show"
    content-class="v-dialog-right rounded-xl"
    width="900px"
    transition="slide-x-reverse-transition"
  >
    <v-card class="rounded-xl">

      <v-card-title>
        Заявление {{personFullName}}
        <v-spacer/>
        <v-btn
          small
          icon
          @click="show = false"
        >
          <v-icon small>
            fa-times
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-container fluid>

        <v-card-text>
          <v-card
            flat
            outlined
            rounded="xl"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{achievementType}}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Выбранный тип деятельности
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-card-text>

        <v-card-text>

          <the-student-scholarship-score-card
            :person-scores="statementScores"
            :is-person-scores-present="true"
          />
        </v-card-text>

        <v-card-text>
          <v-card
            outlined
            rounded="xl"
          >
            <the-student-achievements-statements-table
              :achievements="statementAchievements"
            />
          </v-card>
        </v-card-text>

      </v-container>

    </v-card>
  </v-dialog>
</template>

<style scoped>
>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 98vh;
  min-height: 98vh;
  overflow-y: auto;
  top: auto;
  right: 20px;
}
</style>